import { create } from "zustand";

interface IagGridFlashNotifications {
  tradeBlotterFlashDuration: number;
  setTradeBlotterFlashDuration: (duration: number) => void;
  creationFlashDuration: number;
  setCreationFlashDuration: (duration: number) => void;
  pricesFlashDuration: number;
  setPricesFlashDuration: (duration: number) => void;
  // LQC-1040: validation flash (red pulsing glow on cells that failed
  // user-input validation — e.g. iceberg reduction, missing leg values).
  // Distinct from the AG Grid row-flash on data updates above; lives in the
  // same store so a future settings UI can expose all flash durations
  // together.
  validationFlashDuration: number;
  setValidationFlashDuration: (duration: number) => void;
}

const DEFAULT_FLASH_DURATION = 1000;
const DEFAULT_VALIDATION_FLASH_DURATION = 3000;

function getInitialDuration(key: string, fallback: number): number {
  if (typeof window === "undefined") return fallback;
  const stored = localStorage.getItem(key);
  return stored ? Number(stored) : fallback;
}

const agGridFlashNotifications = create<IagGridFlashNotifications>((set) => ({
  tradeBlotterFlashDuration: getInitialDuration(
    "tradeBlotterFlashDuration",
    DEFAULT_FLASH_DURATION,
  ),
  setTradeBlotterFlashDuration: (duration) =>
    set(() => {
      localStorage.setItem("tradeBlotterFlashDuration", duration.toString());
      return { tradeBlotterFlashDuration: duration };
    }),
  creationFlashDuration: getInitialDuration(
    "creationFlashDuration",
    DEFAULT_FLASH_DURATION,
  ),
  setCreationFlashDuration: (duration) =>
    set(() => {
      localStorage.setItem("creationFlashDuration", duration.toString());
      return { creationFlashDuration: duration };
    }),
  pricesFlashDuration: getInitialDuration(
    "pricesFlashDuration",
    DEFAULT_FLASH_DURATION,
  ),
  setPricesFlashDuration: (duration) =>
    set(() => {
      localStorage.setItem("pricesFlashDuration", duration.toString());
      return { pricesFlashDuration: duration };
    }),
  validationFlashDuration: getInitialDuration(
    "validationFlashDuration",
    DEFAULT_VALIDATION_FLASH_DURATION,
  ),
  setValidationFlashDuration: (duration) =>
    set(() => {
      localStorage.setItem("validationFlashDuration", duration.toString());
      return { validationFlashDuration: duration };
    }),
}));

export default agGridFlashNotifications;
